package com.tovtalk.data.network

import com.tovtalk.utils.logger.Logger
import io.ktor.client.plugins.*
import io.ktor.client.plugins.api.createClientPlugin
import io.ktor.client.statement.*
import io.ktor.http.contentLength
import io.ktor.util.*

private const val TAG = "TT_VIDEO"

class BandwidthInterceptorConfig {
    var estimator: BandwidthEstimator? = null
}

val BandwidthInterceptorPlugin = createClientPlugin("BandwidthInterceptor", ::BandwidthInterceptorConfig) {
    val estimator = pluginConfig.estimator ?: return@createClientPlugin

    onResponse { response ->
        val contentLength = response.contentLength() ?: return@onResponse
        val requestTime = response.requestTime.timestamp
        val responseTime = response.responseTime.timestamp
        val durationMs = responseTime - requestTime
        val url = response.request.url.toString()
        val urlShort = if (url.length > 60) "...${url.takeLast(60)}" else url
        if (durationMs > 0) {
            val speedKbps = ((contentLength * 8).toDouble() / (durationMs.toDouble() / 1000.0) / 1000.0).toInt()
            Logger.d("http_response | speed=${speedKbps}kbps | bytes=$contentLength | duration_ms=$durationMs | url=$urlShort", TAG)
            estimator.recordSample(contentLength, durationMs)
        }
    }
}
